module.exports = __webpack_public_path__ + "bg_infos.png?c588b50bdbb6303110f13ba84322b8bf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_infos.png
// module id = 55
// module chunks = 0